import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

import clinicalBase1 from "../../../../images/base/clinic_base-1.jpg";
import clinicalBase2 from "../../../../images/base/clinic_base-2.jpg";

export default function ClinicalBase() {
  useSEO(seoConfig.clinicalBase);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Клиническая база ГБУ СО "УрНИИДВиИ"
      </h1>

      <img
        alt="Клиника УрНИИ"
        className="clinicalbase__image"
        src={clinicalBase1}
      ></img>

      <img
        alt="Экспериментально-лабораторная база"
        className="clinicalbase__image"
        src={clinicalBase2}
      ></img>
    </section>
  );
}
